import * as React from "react";

const useAsync = (
  cb,
  options?: {
    onSuccess?: (data?: any) => void;
    onError?: (error?: Error) => void;
  }
) => {
  const [state, dispatch] = React.useReducer(
    (state, action) => {
      switch (action.type) {
        case "pending":
          return { ...state, loading: true, status: "pending" };
        case "success":
          return {
            ...state,
            loading: false,
            value: action.payload,
            status: "success"
          };
        case "error":
          return {
            ...state,
            loading: false,
            error: action.payload,
            status: "error"
          };
        default:
          return state;
      }
    },
    { loading: false, status: "idle" }
  );

  const run = React.useCallback(
    async (...args) => {
      dispatch({ type: "pending" });
      try {
        const value = await cb(...args);
        dispatch({ type: "success", payload: value });
        options?.onSuccess?.(value);
      } catch (error: any) {
        dispatch({ type: "error", payload: error });
        options?.onError?.(error);
      }
    },
    [cb]
  );

  return {
    ...state,
    run
  };
};

export default useAsync;
